export default __webpack_public_path__ + "static/media/InTheZone.cf3e89a6.mp4";